<template>
    <v-expansion-panel-header :color="'var(--color-bg-shaded)'">
        <div class="d-flex align-center gap-1">
            <v-icon
                left
                color="primary"
                aria-hidden="true"
            >{{ icon }}</v-icon>

            <div>
                <p class="ma-0 mb-1 font-weight-bold">{{ title }}</p>
                <p class="mb-0 caption text--secondary">{{ subtitle }}</p>
            </div>
        </div>
    </v-expansion-panel-header>
</template>

<script>
export default {
    name: 'ExpansionPanelHeaderRich',

    props: {
        icon: {
            type: String,
            default: 'mdi-cog-outline'
        },

        title: {
            type: String,
            default: ''
        },

        subtitle: {
            type: String,
            default: ''
        }
    }
}
</script>